import { useContext } from "react";
import UserContext from "../../contexts/UserContext";
import { extractPermission } from "../../helpers/extract";
import ProfileIcon from "../../components/ProfileIcon";
import { GiBilledCap } from "react-icons/gi";
import { MdAttachEmail } from "react-icons/md"; 
import { FaUserCircle } from "react-icons/fa";
import { AiFillPhone } from "react-icons/ai";

function Profile() {
  const { user } = useContext(UserContext);
  const permission = extractPermission(user);
  const userInfo: any = user;
  return <>
  <div
    className="relative min-h-screen p-12 overflow-hidden text-center"
  >
    <div
      className="absolute top-0 bottom-0 left-0 right-0 w-full h-full overflow-hidden bg-fixed bg-slate-200"
    >
      <div className="flex items-center justify-center h-full">
        <div className="px-6 text-center md:px-12">
          {/* Profile Icon */}

          <div className="flex justify-center w-max-xl">
            <div className="relative block max-w-xl p-6 bg-white rounded-lg shadow-lg grow">
              

              <div className="absolute flex justify-center w-24 h-24 -left-3 -top-3">
                <div className="grid grid-rows-3">
                  <div className="row-start-2">
                    <ProfileIcon permission={permission.role} />
                  </div>
                </div>
              </div>

              <h5 className="pb-4 mx-16 mb-4 text-2xl font-medium leading-tight text-blue-500 uppercase border-b-2 border-dotted">
                Profile
              </h5>

              <div className="grid grid-cols-2 my-4">

                <div className="px-3 py-3 mx-2 my-2 bg-blue-300 text-center rounded-lg col-span-2 flex flex-col justify-center items-center gap-1">
                  {/* <div className="text-center text-white py-1 flex gap-1 justify-center"> */}
                    <FaUserCircle size={24} color={"white"}/> 
                  {/* </div> */}
                  <div className="flex gap-1 justify-center items-center">
                    {permission.name ? (
                        `${permission.name}`
                      ) : (
                        <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-gray-200 text-gray-700 rounded-full">
                          None
                        </span>
                      )}

                    <p className="opacity-50 text-xs">
                      - ({userInfo.username})
                    </p>
                  </div>
                </div>

                <div className="px-3 py-3 mx-2 my-2 bg-blue-300 text-center rounded-lg align-middle col-span-2">
                  <div className="text-center text-white py-1 flex gap-1 justify-center">
                    <MdAttachEmail size={24} />
                  </div>
                  <div>
                    {permission.email ? (
                      permission.email
                    ) : (
                      <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-gray-200 text-gray-700 rounded-full">
                        None
                      </span>
                    )}
                  </div>
                </div>

                <div className="px-3 py-3 mx-2 my-2 bg-blue-300 text-center rounded-lg align-middle">
                  <div className="text-center text-white py-1 flex gap-1 justify-center">
                    <AiFillPhone size={24} />
                  </div>
                  <div className="">
                    {userInfo.phone_number ? (
                      userInfo.phone_number
                    ) : (
                      <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-gray-200 text-gray-700 rounded-full">
                        None
                      </span>
                    )}
                  </div>
                </div>

                <div className="px-3 py-3 mx-2 my-2 bg-blue-300 text-center rounded-lg align-middle">
                  <div className="text-center text-white py-1 flex gap-1 justify-center">
                    <GiBilledCap size={24} color={"white"}/>
                  </div>
                  <div className="">
                    {permission.role}
                  </div>
                </div>

              </div>

              <button
                onClick={() => {
                  var delayInMilliseconds = 400; //400 millisecond
                  setTimeout(() => {
                    window.location.reload();
                  }, delayInMilliseconds);
                }}
                className="mt-2 btn-submit"
              >
                Refresh Permission
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>;
}

export default Profile;
